module.exports = __webpack_public_path__ + "img/帐篷.224cc1af.png";